module.exports = ":host{border:none;color:inherit;padding:0;background:transparent;cursor:pointer}:host[disabled]{opacity:.5 !important;cursor:default}svg{height:21px;width:21px;fill:currentColor}.left{-webkit-transform:rotate(180deg);-moz-transform:rotate(180deg);-ms-transform:rotate(180deg);-o-transform:rotate(180deg);transform:rotate(180deg)}\n"


//////////////////
// WEBPACK FOOTER
// ./src/GhContribCalendar/Chevron/Chevron.scss
// module id = 31
// module chunks = 0 1